import React, { useState } from "react";
import { 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaClock, 
  FaPaperPlane, 
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../axios/api";

const Contacto = () => {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    assunto: "",
    mensagem: ""
  });

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedback({ type: "", message: "" });

    try {
      // Ajusta a rota conforme a tua API de backend (ex: /contacto ou /mensagens)
      await api.post("/contacto", formData);
      
      setFeedback({
        type: "success",
        message: "Mensagem enviada com sucesso! Entraremos em contacto em breve."
      });
      setFormData({ nome: "", email: "", telefone: "", assunto: "", mensagem: "" });
    } catch (err) {
      console.error("Erro ao enviar mensagem:", err);
      setFeedback({
        type: "danger",
        message: "Ocorreu um erro ao enviar a mensagem. Por favor, tente novamente ou use outro canal."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="bg-white text-dark">
      <Header />

      {/* Hero / Page Banner */}
      <section className="bg-dark text-white py-5 position-relative overflow-hidden">
        <div className="container py-4 position-relative z-1 text-center">
          <span className="badge bg-warning text-dark px-3 py-2 fw-bold text-uppercase rounded-pill mb-3">
            Fale Connosco
          </span>
          <h1 className="display-4 fw-bold mb-3">Estamos aqui para si</h1>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '600px' }}>
            Tem alguma dúvida, projeto em mente ou precisa de suporte? Entre em contacto connoscocel através dos nossos canais ou envie-nos uma mensagem.
          </p>
        </div>
      </section>

      {/* Contact Information & Form Section */}
      <section className="py-5">
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Contact Info Sidebar */}
            <div className="col-lg-5">
              <div className="pe-lg-4">
                <h3 className="fw-bold mb-4 text-dark">Informações de Contacto</h3>
                <p className="text-muted mb-4">
                  Visite-nos ou entre em contacto através de um dos nossos meios diretos de atendimento.
                </p>

                <div className="d-flex flex-column gap-4 mb-5">
                  
                  {/* Address */}
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-warning bg-opacity-10 text-warning p-3 rounded-4 fs-5 d-flex align-items-center justify-content-center" style={{ minWidth: '50px', height: '50px' }}>
                      <FaMapMarkerAlt />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-1 fs-6">Localização</h5>
                      <p className="text-muted mb-0 small">Huambo, Angola</p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-warning bg-opacity-10 text-warning p-3 rounded-4 fs-5 d-flex align-items-center justify-content-center" style={{ minWidth: '50px', height: '50px' }}>
                      <FaPhoneAlt />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-1 fs-6">Telefone</h5>
                      <a href="tel:+24493328889" className="text-muted text-decoration-none small d-block">
                        +244 933 288 89
                      </a>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-warning bg-opacity-10 text-warning p-3 rounded-4 fs-5 d-flex align-items-center justify-content-center" style={{ minWidth: '50px', height: '50px' }}>
                      <FaEnvelope />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-1 fs-6">E-mail</h5>
                      <a href="mailto:cenfotep@outlook.com" className="text-muted text-decoration-none small d-block">
                        cenfotep@outlook.com
                      </a>
                    </div>
                  </div>

                  {/* Working Hours */}
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-warning bg-opacity-10 text-warning p-3 rounded-4 fs-5 d-flex align-items-center justify-content-center" style={{ minWidth: '50px', height: '50px' }}>
                      <FaClock />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-1 fs-6">Horário de Atendimento</h5>
                      <p className="text-muted mb-0 small">Segunda a Sexta: 08:00 - 17:00</p>
                    </div>
                  </div>

                </div>

                {/* Social Links */}
                <div>
                  <h6 className="fw-bold mb-3">Redes Sociais</h6>
                  <div className="d-flex gap-2">
                    <a href="#" className="btn btn-dark text-warning rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }} aria-label="Facebook">
                      <FaFacebookF size={14} />
                    </a>
                    <a href="#" className="btn btn-dark text-warning rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }} aria-label="Instagram">
                      <FaInstagram size={14} />
                    </a>
                    <a href="#" className="btn btn-dark text-warning rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }} aria-label="LinkedIn">
                      <FaLinkedinIn size={14} />
                    </a>
                    <a href="https://wa.me/24493328889" target="_blank" rel="noopener noreferrer" className="btn btn-dark text-warning rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }} aria-label="WhatsApp">
                      <FaWhatsapp size={14} />
                    </a>
                  </div>
                </div>

              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-7">
              <div className="bg-light p-4 p-md-5 rounded-4 shadow-sm border">
                <h3 className="fw-bold mb-3 text-dark">Envie-nos uma Mensagem</h3>
                <p className="text-muted mb-4 small">
                  Preencha o formulário abaixo e entraremos em contacto o mais breve possível.
                </p>

                {feedback.message && (
                  <div className={`alert alert-${feedback.type} rounded-3 py-3 mb-4`} role="alert">
                    {feedback.message}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    
                    <div className="col-md-6">
                      <label htmlFor="nome" className="form-label small fw-semibold">Nome Completo *</label>
                      <input 
                        type="text" 
                        className="form-control rounded-3 py-2" 
                        id="nome" 
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                        required 
                        placeholder="O seu nome"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="email" className="form-label small fw-semibold">E-mail *</label>
                      <input 
                        type="email" 
                        className="form-control rounded-3 py-2" 
                        id="email" 
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required 
                        placeholder="exemplo@dominio.com"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="telefone" className="form-label small fw-semibold">Telefone</label>
                      <input 
                        type="tel" 
                        className="form-control rounded-3 py-2" 
                        id="telefone" 
                        name="telefone"
                        value={formData.telefone}
                        onChange={handleChange}
                        placeholder="+244 900 000 000"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="assunto" className="form-label small fw-semibold">Assunto *</label>
                      <input 
                        type="text" 
                        className="form-control rounded-3 py-2" 
                        id="assunto" 
                        name="assunto"
                        value={formData.assunto}
                        onChange={handleChange}
                        required 
                        placeholder="Motivo do contacto"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="mensagem" className="form-label small fw-semibold">Mensagem *</label>
                      <textarea 
                        className="form-control rounded-3 py-2" 
                        id="mensagem" 
                        name="mensagem"
                        rows="5"
                        value={formData.mensagem}
                        onChange={handleChange}
                        required 
                        placeholder="Escreva aqui a sua mensagem..."
                      ></textarea>
                    </div>

                    <div className="col-12 mt-4">
                      <button 
                        type="submit" 
                        className="btn btn-dark text-warning px-5 py-3 rounded-pill fw-bold w-100 d-flex align-items-center justify-content-center gap-2 shadow-sm"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            A enviar...
                          </>
                        ) : (
                          <>
                            <FaPaperPlane /> Enviar Mensagem
                          </>
                        )}
                      </button>
                    </div>

                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

     

      <Footer />
    </main>
  );
};

export default Contacto;